import React from 'react';
import Button from '../Button/Button';
import { DefaultFlex } from '../../Assistant/DefaultStyle';
import FontsDefault from '../../Assistant/DefaultStyle';

function TitleServices({ title, description, showBtn, secondDescription }) {
  return (
    <div className={`${DefaultFlex} items-center mb-6`}>
      <div>
        <h1 className={`${FontsDefault.text2xl} text-amber`}>{title}</h1>
        <h1 className={`py-3 md:${FontsDefault.text3xl} text-xl font-bold text-gray700`}>
          {description}
        </h1>
        {secondDescription && (
          <h1
            className={`py-3 md:${FontsDefault.text2xl} text-lg text-gray700`}
          >
            {secondDescription}
          </h1>
        )}
      </div>
      {showBtn && (
        <div>
          <Button title='اطلب خدمتك الان' />
        </div>
      )}
    </div>
  );
}

export default TitleServices;
